import { AuthApi, IAuthApi, MockAuthApi } from "./auth";
import { DocumentApi } from "./document";
import { DoumentMetadataApi } from "./document-metadata";
import { DocumentMetadataApiV2, IDocumentMetadataApi } from "./document-metadata-v2";
import { DocumentApiV2, IDocumentApi } from "./document-v2";
import { DossierMetadataApi, IDossierMetadataApi, MockDossierMetadataApi } from "./dossier-metadata";
import { IMeldingApi, MeldingApi, MockMeldingApi } from "./meldingen";
import { MockDocumentMetadataApi } from "./mocks/document-metadata.mock";
import { MockDocumentApi } from "./mocks/document.mock";
import { MockSearchApi } from "./mocks/search.mock";
import { MockVerwerkingsoverzichtApi } from "./mocks/verwerkingsoverzicht.mock";
import { ISearchApi, SearchApi } from "./search";
import { IVerwerkingsoverzichtApi, VerwerkingsoverzichtApi } from "./verwerkingsoverzicht";

export class ApiFactory {
  public static isTestSuite = globalThis.location.host === "localhost:3000";

  public static readonly createSearchApi = (): ISearchApi =>
    ApiFactory.isTestSuite ? new MockSearchApi() : new SearchApi();

  public static readonly createVerwerkingsoverzichtApi = (): IVerwerkingsoverzichtApi =>
    ApiFactory.isTestSuite ? new MockVerwerkingsoverzichtApi() : new VerwerkingsoverzichtApi();

  public static readonly createDocumentApi = (): IDocumentApi =>
    ApiFactory.isTestSuite
      ? new MockDocumentApi()
      : process.env.REACT_APP_OAS_V2 === "true"
        ? new DocumentApiV2()
        : new DocumentApi();

  public static readonly createDocumentMetadataApi = (): IDocumentMetadataApi =>
    ApiFactory.isTestSuite
      ? new MockDocumentMetadataApi()
      : process.env.REACT_APP_OAS_V2 === "true"
        ? new DocumentMetadataApiV2()
        : new DoumentMetadataApi();

  public static readonly createDossierMetadataApi = (): IDossierMetadataApi =>
    ApiFactory.isTestSuite ? new MockDossierMetadataApi() : new DossierMetadataApi();

  public static readonly createAuthApi = (): IAuthApi => (ApiFactory.isTestSuite ? new MockAuthApi() : new AuthApi());

  public static readonly createMeldingenApi = (): IMeldingApi =>
    ApiFactory.isTestSuite ? new MockMeldingApi() : new MeldingApi();
}
